import { render, staticRenderFns } from "./veJkyPaperEdit.vue?vue&type=template&id=5d5d40c0&scoped=true"
import script from "./veJkyPaperEdit.vue?vue&type=script&lang=js"
export * from "./veJkyPaperEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d40c0",
  null
  
)

export default component.exports